module.exports = __webpack_public_path__ + "images/Premium_white_horizontal.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo/Premium_white_horizontal.svg
// module id = 114
// module chunks = 0